import { MatrixClient, MatrixError } from 'matrix-js-sdk/src/matrix';

import logger from 'utils/logging/faro';

export type DismissInviteNotificationParams = {
  kind: 'close' | 'decline';
  notificationId: string;
  roomId: string;
  markAsRead: (id: string) => void;
  removeNotification: (id: string) => void;
  removeToast: (id: string) => void;
  matrixClient?: MatrixClient;
};

export const dismissInviteNotification = (params: DismissInviteNotificationParams): void => {
  const { kind, notificationId, roomId, markAsRead, removeNotification, removeToast, matrixClient } = params;

  markAsRead(notificationId);
  removeToast(notificationId);

  if (kind === 'decline') {
    removeNotification(notificationId);

    if (matrixClient) {
      matrixClient.leave(roomId).catch((error) => {
        const isNotInRoom = error instanceof MatrixError && error.errcode === 'M_NOT_IN_ROOM';
        if (isNotInRoom) {
          logger.warn(`Room ${roomId} already left or never joined on invite decline`);
        } else {
          logger.error(`Failed to leave room ${roomId} on invite decline`, { error });
        }
      });
    }
  }
};
